export default __webpack_public_path__ + "static/media/create-first-voice-box.c1ccb70e.svg";